import { render, staticRenderFns } from "./couponPackageReceiveLists.vue?vue&type=template&id=8cb155ea&scoped=true&"
import script from "./couponPackageReceiveLists.vue?vue&type=script&lang=js&"
export * from "./couponPackageReceiveLists.vue?vue&type=script&lang=js&"
import style0 from "./couponPackageReceiveLists.vue?vue&type=style&index=0&id=8cb155ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb155ea",
  null
  
)

export default component.exports